import React, { useState, useEffect } from "react"
import { Spinner, Table, Button } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { fetchPreEnrolsAction } from "../../pages/pre-enrolment/preEnrolmentAction"
import { NoData } from "../no-data/NoData"
import "./preEnrolmentTable.css"

export const PreEnrolmentTable = () => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.user)
  const [preEnrols, setPreEnrols] = useState([])
  const { isLoading, preEnrolments } = useSelector((state) => state.preEnrol)
  const [shouldFetch, setShouldFetch] = useState(true)

  useEffect(() => {
    if (user?.branch) {
      const params = new URLSearchParams()
      params.set("branch", user?.branch)
      shouldFetch && dispatch(fetchPreEnrolsAction(params.toString()))
      setShouldFetch(false)
      setPreEnrols(preEnrolments)
    }
  }, [shouldFetch, user?.branch, dispatch, preEnrolments])

  const onSearch = (str) => {
    const { value } = str.target
    const newArray = preEnrolments.filter((p) =>
      (p.fName.toLowerCase() + " " + p.lName.toLowerCase()).includes(
        value.toLowerCase()
      )
    )
    setPreEnrols(newArray)
  }

  if (isLoading) {
    return <Spinner animation="border" variant="primary" />
  }

  return (
    <div>
      <div className="search-wrapper mb-3">
        <label className="search-label" htmlFor="search-form">
          <input
            type="search"
            name="search-form"
            id="search-form"
            className="search-input"
            placeholder="Search name..."
            onChange={onSearch}
          />
        </label>
      </div>
      <div className="mb-3">{preEnrols?.length} Pre-Enrolments found!</div>

      {!preEnrols.length ? (
        <NoData />
      ) : (
        <div className="table-responsive">
          <Table striped bordered hover className="text-center">
            <thead>
              <tr>
                <th>#</th>
                <th>Progress</th>
                <th>Name</th>
                <th>Date</th>
                <th>Course Name</th>
                <th>Location</th>
                {/* <th>Code</th> */}
                {/* <th>Discounted Fee</th> */}
                <th>Info</th>
              </tr>
            </thead>
            <tbody>
              {preEnrols.map((preEnrol, index) => (
                <tr key={preEnrol._id}>
                  <td>{index + 1}</td>
                  <td
                    className={
                      preEnrol?.progress === "cancelled"
                        ? "text-danger"
                        : preEnrol?.progress === "complete"
                        ? "text-success"
                        : "text-info"
                    }
                  >
                    {preEnrol?.progress}
                  </td>
                  <td>{`${preEnrol?.fName} ${preEnrol?.lName}`}</td>
                  <td>{new Date(preEnrol?.createdAt).toLocaleDateString()}</td>
                  <td>{preEnrol?.course?.name}</td>
                  <td>{preEnrol?.location?.toUpperCase()}</td>
                  {/* <td>{preEnrol?.referralCode}</td> */}
                  {/* <td>${preEnrol?.fees?.discountedFee} </td> */}
                  <td>
                    <Link to={`/pre-enrolInfo/${preEnrol._id}`}>
                      <Button variant="success">Info</Button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  )
}
